/* eslint-disable no-undef-init */
import React, { useContext } from 'react';

import { RepossessionTabs } from './Repossessions.constants';
import { repossessionContext } from './RepossessionsContext';
import { CreateRoute } from './createRepossession/CreateRoute';
import Routes from './routes/Routes';

export const Repossessions = () => {
	const { viewTab } = useContext(repossessionContext);
	return viewTab === RepossessionTabs.repossession ? (
		<CreateRoute />
	) : (
		<Routes />
	);
};
